import { rightsizingDismissedRecommendationsSelector } from "../rightsizingRecommendationsSelector";
import { RootState } from "../../../../store";

export const rightsizingDismissedRecommendationsLoadingSelector = (
  state: RootState,
): boolean => {
  return !!rightsizingDismissedRecommendationsSelector(state)?.isLoading;
};
